@if (!isProduction) {
  <div class="alert alert-danger text-center mb-0 p-2" role="alert">
    ** {{env}} - {{buildReference}} **
  </div>
}
